import { requestPartnerUrl } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';
import { getMessageDataAsObject } from '@PROJECT_ROOT/assets/shared/js/partnerMessaging';

export default function getPartnerUrl(timeout = 200) {
    window.parent.window.postMessage(requestPartnerUrl(), '*');

    return new Promise((resolve) => {
        const windowMessageHandler = ({ data }) => {
            // Ovo je način da provjerimo u testovima da se ovaj event handler uklonio nakon resolve-anja promise-a
            if (process.env.NODE_ENV !== 'production') {
                const invisibleSentinel = document.createElement('span');
                invisibleSentinel.setAttribute('data-testid', 'eventListenerStillAttachedSentinel');
                document.body.appendChild(invisibleSentinel);
            }

            window.removeEventListener('message', windowMessageHandler);

            resolve(getMessageDataAsObject(data).url);
        };

        window.addEventListener('message', windowMessageHandler);

        setTimeout(() => {
            window.removeEventListener('message', windowMessageHandler);
            resolve(null);
        }, timeout);
    });
}
